/**
 * Parse StockDashboard_Capital.dist_payments_json for the Distribution card.
 */
export function parsePayments(jsonStr, currency) {
  try {
    const arr = JSON.parse(jsonStr || "[]");
    if (!Array.isArray(arr)) return [];
    return arr
      .map((p) => ({
        month: Number(p.month),
        amount: Number(p.amount),
        currency: currency || p.currency || null,
        paymentDate: p.paymentDate || null,
        exDivDate: p.exDivDate || null,
      }))
      .filter((p) => Number.isFinite(p.month) && p.month >= 1 && p.month <= 12 && Number.isFinite(p.amount));
  } catch {
    return [];
  }
}

/** Normalise dividendPayments depuis l’API (legacy amountEur ou parsePayments). */
export function resolveDividendPayments(distribution) {
  if (!distribution) return [];
  const currency = distribution.currency || "EUR";
  const fromJson = parsePayments(
    distribution.distPaymentsJson ?? distribution.dist_payments_json,
    currency
  );
  if (fromJson.length > 0) return fromJson;

  const legacy = Array.isArray(distribution.dividendPayments) ? distribution.dividendPayments : [];
  return legacy
    .map((p) => ({
      month: Number(p.month),
      amount: Number(p.amount ?? p.amountEur),
      currency: p.currency || currency,
      paymentDate: p.paymentDate || null,
      exDivDate: p.exDivDate || null,
    }))
    .filter((p) => Number.isFinite(p.month) && p.month >= 1 && p.month <= 12);
}
